module.exports = __webpack_public_path__ + "c636b9b677fbd28b6596bf4ff1043f44.woff2";